import React from 'react'
import PropTypes from 'prop-types'
import { QueryClient, QueryClientProvider } from 'react-query'

import {
  AppContextProvider,
  RouterContextProvider,
  OverlayContextProvider,
  ModalContextProvider,
  AmplitudeContextProvider,
} from '../../contexts'

import { EMBEDDED } from '../../constants/build'

const ListingLaunchPadInterface = ({
  // drives behavior - must be set by props or internally
  address,
  listingPrice,

  // required for EMBEDDED
  customerProfileId,
  clientAuthToken,
  customerPublicKey,

  // defaulted
  queryClient = new QueryClient(),
  widgetMode = EMBEDDED,
  devMode = false,

  // amplitude instance for tracking
  amplitudeInstance,

  children,
}) => {
  const hasCustomer = Boolean(customerProfileId)
  const hasAuth = Boolean(clientAuthToken || customerPublicKey)
  const hasEmbedProps = hasCustomer && hasAuth

  if (widgetMode === EMBEDDED && !hasEmbedProps) {
    console.warn(
      'ListingLaunchPad export missing required props. Nothing rendered.'
    )
    return
  }

  return (
    <AppContextProvider
      address={address}
      listingPrice={listingPrice}
      customerProfileId={customerProfileId}
      clientAuthToken={clientAuthToken}
      customerPublicKey={customerPublicKey}
      widgetMode={widgetMode}
      devMode={devMode}
    >
      <QueryClientProvider client={queryClient}>
        <RouterContextProvider>
          <OverlayContextProvider>
            <AmplitudeContextProvider ampli={amplitudeInstance}>
              <ModalContextProvider>{children}</ModalContextProvider>
            </AmplitudeContextProvider>
          </OverlayContextProvider>
        </RouterContextProvider>
      </QueryClientProvider>
    </AppContextProvider>
  )
}

ListingLaunchPadInterface.propTypes = {
  address: PropTypes.string,
  listingPrice: PropTypes.number,
  widgetMode: PropTypes.string,
  devMode: PropTypes.bool,
  queryClient: PropTypes.object,
  clientAuthToken: PropTypes.string,
  customerPublicKey: PropTypes.string,
  customerProfileId: PropTypes.string,
  children: PropTypes.any,
  amplitudeInstance: PropTypes.object,
}

export default ListingLaunchPadInterface
